import { ReactText } from 'react';
import { toast } from 'react-toastify';

export const dispatchWarningToast = (
  render: string,
  autoClose: number | false = 3000,
  toastId?: ReactText
): ReactText => {
  if (toastId) {
    toast.update(toastId, {
      render,
      type: 'error',
      isLoading: false,
      closeButton: true,
      closeOnClick: true,
      autoClose,
      hideProgressBar: true,
    });
    return toastId;
  }
  return toast.warn(render, { autoClose });
};

export const dispatchErrorToast = (
  render: string,
  autoClose: number | false = false,
  toastId?: ReactText
): ReactText => {
  if (toastId) {
    toast.update(toastId, {
      render,
      type: 'error',
      isLoading: false,
      closeButton: true,
      closeOnClick: true,
      autoClose,
      hideProgressBar: true,
    });
    return toastId;
  }
  return toast.error(render, {
    autoClose,
    hideProgressBar: !autoClose ? true : false,
  });
};

/** @param autoClose - number of milliseconds to auto-close toast, or false to not autoclose */
export const dispatchSuccessToast = (
  render: string,
  autoClose: number | false = 2000,
  toastId?: ReactText
): ReactText => {
  if (toastId) {
    toast.update(toastId, {
      render,
      type: 'success',
      isLoading: false,
      autoClose,
      closeButton: true,
      closeOnClick: true,
    });
    return toastId;
  }
  return toast.success(render, { autoClose });
};

export const dispatchInfoToast = (
  render: string,
  autoClose: number | false = 2000
): void => {
  toast(render, {
    type: 'info',
    autoClose,
  });
};
